import imgBtn from '@assets/web-v3-images/btn-popup.png';
import imgPuzzle from '@assets/web-v3-images/icons/puzzle.png';
import img100 from '@assets/web-v3-images/img-100-popup.png';
import img1000 from '@assets/web-v3-images/img-1000-popup.png';
import img500 from '@assets/web-v3-images/img-500-popup.png';
import img5000 from '@assets/web-v3-images/img-5000-popup.png';
import userImg from '@assets/web-v3-images/user-popup.png';
import coinImg from '@assets/web-v3-images/icons/crown-coin-icon.png';
import { Text } from '@radix-ui/themes';
import FrameTreasure from '.';
import Buttons from '../Buttons';

export default function Treasure({
	onOpenChange,
	open,
	handleClick,
	type = '',
	textBtn = 'Text demo',
	textDescribe = 'Lorem ipsum, dolor sit amet consectetur adipisicing elit.',
	valuePuzzle = '9,999,999',
	valueCoin,
	hiddenIconPuzzle = false,
	title = "Congratulation!",
}) {

	// truyền type 1, 2 , 3, 4 để có UI tương ứng với phần thưởng, nếu không truyền sẽ là userImg
	let imgs = null;
	switch (type) {
		case 1:
			imgs = img100;
			break;
		case 2:
			imgs = img500;
			break;
		case 3:
			imgs = img5000;
			break;
		case 4:
			imgs = img1000;
			break;
		default:
			imgs = userImg;
	}

	return (
		<FrameTreasure
			open={open}
			onOpenChange={onOpenChange}
			hiddenIconExit={false}
			title={title}
		>
			<Text
				as="p"
				className="
        w-full
        text-center
        text-[#FEF7C3]
        font-bold
        text-[16px]
        md:text-[18px]
        px-5 sm:px-13
        [text-shadow:0_1px_3px_rgba(0,0,0,0.8)]
    "
			>
				{textDescribe}
			</Text>
			{valueCoin &&
				<div className='flex gap-2 items-center justify-center py-4 relative z-10'>
					<img src={coinImg} alt="coin" className='h-full w-10 sm:w-12' />
					<span
						className='font-extrabold text-[30px] sm:text-[40px]'
						style={{
							backgroundImage: `
						linear-gradient(
							180deg,
							rgba(254, 247, 195, 1) 0%,
							rgba(254, 247, 195, 1) 40%,
							rgba(253, 226, 114, 1) 50%,
							rgba(254, 247, 195, 1) 60%,
							rgba(254, 247, 195, 1) 100%
						)
					`,
							WebkitBackgroundClip: "text",
							backgroundClip: "text",
							color: "transparent",
							WebkitTextStroke: "1px rgba(234, 170, 8, 1)",
							paintOrder: "stroke fill",
							filter: "drop-shadow(0 4px 4px rgba(0, 0, 0, 0.25))",
						}}
					>
						{valueCoin}
					</span>
				</div>
			}
			<div className="relative w-full">
				<img
					src={imgs}
					alt="100"
					className="block w-full h-full -mt-[110px] sm:-mt-[140px]"
				/>
				{valueCoin ?
					<div className='relative !top-1 sm:-top-10 px-15 sm:px-30'>
						<Buttons handleClick={handleClick} textBtn={textBtn} />
					</div>
					:
					<div
						className="
						absolute
						left-1/2
						bottom-[-20px]
						translate-y-1/3
						-translate-x-1/2
						w-[90%]
						aspect-[300/70]
						flex
						items-center
						justify-center
						gap-2
						px-6
						z-10"
						style={{
							backgroundImage: `url(${imgBtn})`,
							backgroundSize: "100% 100%",
							backgroundRepeat: "no-repeat",
						}}
					>
						{!hiddenIconPuzzle &&
							<img
								src={imgPuzzle}
								alt="puzzle"
								className="w-[16%] max-w-[56px] min-w-[36px] h-auto"
							/>
						}

						<div className="relative inline-block">
							<span
								className="absolute inset-0 font-black select-none"
								style={{
									fontSize: "clamp(24px,4vw,40px)",
									WebkitTextStroke: "3px #D92D20",
									color: "#FF692E",
									paintOrder: "stroke fill",
									textShadow: "0 4px 4px rgba(0,0,0,.25)",
								}}
							>
								{valuePuzzle}
							</span>

							<span
								className="
						relative
						font-black
						bg-gradient-to-b
						from-[#FEF7C3]
						to-[#FDE272]
						bg-clip-text
						text-transparent
        "
								style={{
									fontSize: "clamp(24px,4vw,40px)",
								}}
							>
								{valuePuzzle}
							</span>
						</div>
					</div>
				}
			</div>
			{!valueCoin &&
				<div className='px-[20%] pt-15 sm:pt-16 md:pt-20 0 lg:pt-20 xl:pt-20'>
					<Buttons handleClick={handleClick} textBtn={textBtn} />
				</div>
			}
		</FrameTreasure>
	)
}
